import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowReply = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 14,
	viewBox: "0 0 17 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3018_125294)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.07412 3.48595C8.29092 3.53197 9.49178 3.74957 10.6236 4.192C14.2421 5.60674 16.8723 9.16922 16.9951 13.0538C17.0051 13.3759 17.0363 13.8697 16.6298 13.9755C16.0925 14.1155 15.9643 13.6244 15.7338 13.2846C14.9561 12.1374 14.1298 11.246 12.9436 10.4978C11.1728 9.38156 9.16699 8.98646 7.07412 9.09953V12.2347C7.07412 12.2557 6.97117 12.4043 6.94261 12.4332C6.76926 12.6127 6.46971 12.6653 6.26049 12.5141C4.35293 10.6904 2.43807 8.87798 0.555749 7.03068C0.254206 6.73484 -0.227997 6.47846 0.122696 5.98014L6.22794 0.104914C6.42388 -0.054835 6.76793 -0.027224 6.94062 0.15422C6.97117 0.185775 7.07346 0.354071 7.07346 0.383654V3.48595H7.07412Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3018_125294",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 17,
			height: 14,
			fill: "currentColor"
		})
	}) })]
});
export default SvgArrowReply;
